import React, { useEffect } from 'react';
import './EventModal.css';

const EventModal = ({ event, backendUrl, onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  const imgSrc = event.image_path ? `${backendUrl}${event.image_path}` : null;

  return (
    <div className="event-modal-overlay" onClick={onClose}>
      <div
        className="event-modal-card"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={event.title}
      >
        <button className="event-modal-close" onClick={onClose} aria-label="Close">
          &#10005;
        </button>

        {/* Top: title left, large image top-right */}
        <div className="event-modal-top">
          <h2 className="event-modal-title">{event.title}</h2>
          {imgSrc && (
            <div className="event-modal-image">
              <img src={imgSrc} alt={event.title} />
            </div>
          )}
        </div>

        {event.description && <div className="event-modal-divider" />}

        {/* Description fills remaining vertical space with scroll */}
        {event.description && (
          <div className="event-modal-description-wrap">
            <p className="event-modal-description">{event.description}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventModal;
